import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { SagaIterator } from 'redux-saga';
import achievementsService from '@/services/achievementsService';
import {
    fetchAchievementsRequest,
    fetchAchievementsSuccess,
    fetchAchievementsFailure,
    fetchLastAchievementRequest,
    fetchLastAchievementSuccess,
    fetchLastAchievementFailure,
} from '../slices/achievementsSlice';
import { IGetListAchievementsParams } from '@/features/student/StudentAchievements/interface';

// Worker Sagas
function* fetchAchievementsWorker(action: PayloadAction<IGetListAchievementsParams>): SagaIterator {
    try {
        const response = yield call(achievementsService.getAchievements, action.payload);
        yield put(fetchAchievementsSuccess(response));
    } catch (error: any) {
        yield put(fetchAchievementsFailure(error.response?.data?.message || 'Failed to fetch achievements'));
    }
}

function* fetchLastAchievementWorker(): SagaIterator {
    try {
        const response = yield call(achievementsService.getLastAchievement);
        yield put(fetchLastAchievementSuccess(response));
    } catch (error: any) {
        yield put(fetchLastAchievementFailure(error.response?.data?.message || 'Failed to fetch last achievement'));
    }
}

// Watcher Saga
function* watchAchievements(): SagaIterator {
    yield takeLatest(fetchAchievementsRequest.type, fetchAchievementsWorker);
    yield takeLatest(fetchLastAchievementRequest.type, fetchLastAchievementWorker);
}

export default watchAchievements;
